module.exports = "<!-- Always empty -->\n"